import { useEffect, useState } from "react";
import api from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1581097543550-b3cbe2e6ea6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx1cyUyMGNhcGl0b2wlMjBidWlsZGluZyUyMHdhc2hpbmd0b24lMjBkY3xlbnwwfHx8fDE3ODI2NjMyODF8MA&ixlib=rb-4.1.0&q=85";

export default function History() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/history").then(r => setData(r.data)); }, []);

  if (!data) return <div className="max-w-5xl mx-auto px-6 py-32 text-slate-500">Loading…</div>;

  return (
    <div data-testid="history-page" className="pb-24">
      <section className="relative">
        <div className="absolute inset-0">
          <img src={HERO} alt="U.S. Capitol" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#0A192F]/80" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-32 text-[#FDFBF7]">
          <div className="label-eyebrow text-[#C5A059]">{data.subtitle}</div>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl">{data.title}</h1>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {data.stats.map(s => (
            <div key={s.label} className="card-flat p-6 text-center">
              <div className="font-display text-4xl text-[#002855]">{s.value}</div>
              <div className="label-eyebrow mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-12">
        <div className="label-eyebrow">A brief history</div>
        <h2 className="mt-3 font-display text-4xl sm:text-5xl text-[#0A192F]">Forty-eight years, ten thousand stories.</h2>
        <div className="mt-12 relative">
          <div className="absolute left-3 top-1 bottom-1 w-px bg-[#C5A059]/40" />
          <div className="space-y-12">
            {data.milestones.map((m, i) => (
              <div key={i} className="relative pl-12" data-testid={`milestone-${i}`}>
                <div className="absolute left-0 top-2 w-6 h-6 rounded-full bg-[#FDFBF7] border-2 border-[#C5A059] flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-[#002855]" />
                </div>
                <div className="label-eyebrow text-[#9B111E]">{m.year}</div>
                <h3 className="mt-1 font-display text-2xl text-[#0A192F]">{m.title}</h3>
                <p className="mt-2 text-slate-700 leading-relaxed">{m.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-12">
        <div className="card-flat p-10 bg-white">
          <div className="label-eyebrow">From the charter</div>
          <blockquote className="mt-4 font-display text-2xl sm:text-3xl text-[#0A192F] leading-snug">
            "To attract to the federal service men and women of exceptional ability and dedication, and to develop them as leaders for a lifetime of public service."
          </blockquote>
          <div className="mt-6 text-sm text-slate-500">— Adapted from Executive Order 12008, 1977</div>
        </div>
      </section>
    </div>
  );
}
